import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";

/**
 * Customer picker backed by the /customers table.
 * onChange(name, customerId, customerObj) — customerObj is the full record (or null in manual mode).
 */
export function CustomerPicker({ name, customerId, onChange, testid, placeholder = "Select a customer" }) {
  const [customers, setCustomers] = useState([]);
  const [manual, setManual] = useState(() => !!(name && !customerId));

  useEffect(() => {
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, []);

  const choose = (v) => {
    if (v === "__manual__") { setManual(true); onChange("", "", null); return; }
    const c = customers.find((x) => x.id === v);
    if (c) onChange(c.name, c.id, c);
  };

  if (manual) {
    return (
      <div>
        <Input value={name || ""} placeholder="Type a customer name"
          onChange={(e) => onChange(e.target.value, "", null)} data-testid={testid} />
        {customers.length > 0 && (
          <button type="button" className="mt-1 text-xs text-primary hover:underline"
            onClick={() => { setManual(false); onChange("", "", null); }}
            data-testid={`${testid}-fromlist`}>
            Choose from list
          </button>
        )}
      </div>
    );
  }

  const selectVal = customerId && customers.some((c) => c.id === customerId) ? customerId : "";
  return (
    <Select value={selectVal} onValueChange={choose}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {customers.map((c) => (
          <SelectItem key={c.id} value={c.id}>{c.name}{c.phone ? ` · ${c.phone}` : ""}</SelectItem>
        ))}
        <SelectItem value="__manual__">✏️ Enter manually…</SelectItem>
      </SelectContent>
    </Select>
  );
}
